import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import moment, { Moment } from 'moment';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { environment } from 'src/environments/environment';

export interface ConsultationInfos {
  consultationTitle: string;
  consultationDate: Date;
  consultationType?: string;
}

@Component({
  selector: 'app-modal-create-consultation',
  templateUrl: './modal-create-consultation.component.html',
  styleUrls: [
    './modal-create-consultation.component.scss',
    '../../modal/modal.fragment.scss'
  ]
})
export class ModalCreateConsultationComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;
  public printReferentHeader: boolean;
  public typeConsultationSelectList: Referentiel[];

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _ref: ReferentielService,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit(): void {
    this._initData();
  }

  private async _initData(): Promise<void> {
    try {
      this.typeConsultationSelectList = await this._ref.findRefListTable(ReferentielEnum.typeConsultation);

      this.formGroup = this._formBuilder.group({
        consultationTitle: ['', Validators.required],
        consultationDate: [moment().format('YYYY-MM-DD'), [Validators.required, dateValidator]],
        consultationType: [this.typeConsultationSelectList && this.typeConsultationSelectList[0] ? this.typeConsultationSelectList[0].id : undefined]
      });
    } catch (e) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        e && e.message ? e.message : 'Une erreur est survenue lors du chargement des informations de cette page'
      );
      this.closeModal();
    }
  }

  public async createConsultation(): Promise<void>{
    // TODO Create consultation
    this.closeModal({
      consultationTitle: this.formGroup.get('consultationTitle').value,
      consultationDate: moment(this.formGroup.get('consultationDate').value).toDate(),
      consultationType: this.formGroup.get('consultationType').value
        && this.formGroup.get('consultationType').value !== ''
        ? this.formGroup.get('consultationType').value
        : undefined
    });
  }

  public closeModal(consultationInfos?: ConsultationInfos): void {
    this.closeEmitter.emit(consultationInfos);
  }

}

export const dateValidator = (control: AbstractControl): ValidationErrors | null => {
  const dateValue = moment(control.value);
  if (!dateValue) {
    return { invalidDate: true };
  }

  const flags = dateValue.parsingFlags();
  if (!dateValue.isValid() || (flags.parsedDateParts[0] < 1900)) {
    return { invalidDate: true };
  }

  return null;
}
